import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSuperAdmin } from '../utils/jwt.utils';

/**
 * Composant wrapper pour protéger les pages admin
 * Redirige les utilisateurs non-SuperAdmin vers la page d'accueil
 */
const AdminPageWrapper = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSuperAdmin()) {
      console.warn('Accès non autorisé - utilisateur non SuperAdmin');
      navigate('/', { replace: true });
    }
  }, [navigate]);

  // Ne pas rendre les enfants tant que la vérification n'est pas faite
  if (!isSuperAdmin()) {
    return null;
  }

  return <>{children}</>;
};

export default AdminPageWrapper;
